module.exports = __webpack_public_path__ + "static/img/2_7@2x.0db0d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_7@2x.png
// module id = 5T21
// module chunks = 8